export default __webpack_public_path__ + "static/favicon-3db16eda8dfa2b5f1ac6837063b67b7d.ico";